import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { History } from 'lucide-react';
import { getToken } from '../services/tokenService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/maitres-ouvrage/recents`;

export const typeSimulateur = (t) => (['particulier', 'personne_physique'].includes(t) ? 'particulier' : 'professionnel');

const libelle = (mo) => {
  const nom = mo.raison_sociale || `${mo.prenom} ${mo.nom}`.trim();
  const lieu = [mo.code_postal, mo.ville].filter(Boolean).join(' ');
  return `${nom}${lieu ? ` — ${lieu}` : ''}${mo.derniere_utilisation ? ` (${mo.source} du ${mo.derniere_utilisation.split('-').reverse().join('/')})` : ''}`;
};

/** Liste des maîtres d'ouvrage déjà saisis pour le membre ; un choix remplit le formulaire. */
export default function MaitresOuvrageRecents({ membreId, onChoisir }) {
  const [liste, setListe] = useState([]);
  useEffect(() => {
    if (!membreId) { setListe([]); return; }
    axios.get(API, { params: { membre_id: membreId }, headers: { Authorization: `Bearer ${getToken()}` } })
      .then((r) => setListe(r.data.maitres_ouvrage || [])).catch(() => setListe([]));
  }, [membreId]);
  if (!liste.length) return null;
  return (
    <div className="flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2" data-testid="mo-recents">
      <History className="h-4 w-4 shrink-0 text-slate-500" />
      <select className="h-9 w-full rounded-md border border-slate-200 bg-white px-2 text-sm" defaultValue=""
        onChange={(e) => { const mo = liste[Number(e.target.value)]; if (mo) onChoisir({ ...mo, type: typeSimulateur(mo.type) }); e.target.value = ''; }}
        data-testid="mo-recents-select">
        <option value="">Réutiliser un maître d'ouvrage déjà saisi ({liste.length})…</option>
        {liste.map((mo, i) => <option key={i} value={i}>{libelle(mo)}</option>)}
      </select>
    </div>
  );
}
